module.exports = __webpack_public_path__ + "static/img/6areaB_7.3ff7d15.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_7.png
// module id = 1210
// module chunks = 1